module.exports = "/_next/static/images/Trend01Visual-61a54c07078bea26cba4bd36eddbec1f.webp";